import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import DataTable from '../../../components/DataTable';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';
import useUser from '../../../auth/hooks';
import { formatRank, isIntersection } from '../../../utils/helpers';
import useReactRouter from 'use-react-router';
import { useNavigator } from '../../../components/Navigator';
import { MTableToolbar } from 'material-table';
import { useMutation, useQuery } from '@apollo/react-hooks';
import IconButton from '@material-ui/core/IconButton';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { Tooltip } from '@material-ui/core';
import { RANK_PRIORITY_MAP, USER_TYPES } from '../../../utils/enums';
import MyChip from '../../../components/MyChip';
import Loading from '../../../components/Loading';

const getCurrentYear = () => {
  return new Date().getFullYear();
};

const ListAthlete = () => {
  const navigate = useNavigator();
  const { user } = useUser();
  const { match } = useReactRouter();
  let certificationsId = match.params.id;
  let trainerId = match.params.trainerId;
  const api = useApi();
  const { data, loading, onDelete } = useDataList({
    schema: api.schema.certifications_athlete,
    router: null,
    variables: {
      inputFilter: {
        certificationsId: Number(certificationsId),
        trainerId: trainerId,
      },
    },
  });
  const { data: dataCert, loading: certLoading } = useQuery(
    api.schema.certifications.one()[0],
    {
      variables: { id: certificationsId },
      fetchPolicy: 'network-only',
    }
  );
  const { data: dataTrainer } = useQuery(api.schema.trainers.one()[0], {
    variables: { id: trainerId },
    fetchPolicy: 'network-only',
  });
  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    {
      title: t`Імя атлета`,
      field: 'name',
      render: ({ athlete, contributions }) => {
        return contributions.filter((c) => c.year === String(getCurrentYear()))
          .length !== 0 ? (
          (athlete && athlete.fullName) || ''
        ) : (
          <Tooltip title={t`Не здав членський внесок`}>
            <span>
              <MyChip
                label={athlete.fullName}
                color='#db0a0a'
                variant='outlined'
                onClick={() =>
                  navigate(`${api.router.athletes.edit(athlete.id)}?tab=1`)
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: t`Кю`,
      field: 'rank',
      render: ({ rank }) => formatRank(rank) || '',
      customSort: (a, b) =>
        (RANK_PRIORITY_MAP[a.rank] || 0) - (RANK_PRIORITY_MAP[b.rank] || 0),
    },
  ];
  const [generateProfileInfo] = useMutation(
    api.schema.certifications.generateProfileInfo()[0],
    {
      onCompleted: (d) => {
        const res = d[api.schema.certifications.generateProfileInfo()[1]];
        if (res.ok) {
          window.open(res.url, '_blank').focus();
        }
      },
    }
  );

  if (loading || certLoading) return <Loading />;

  return (
    <Paper>
      <DataTable
        isLoading={loading}
        title={
          <div>
            {'Відомість'}
            <br />
            {'Тренер: ' +
              (dataTrainer && dataTrainer.trainer
                ? dataTrainer.trainer.fullName
                : null)}
            <br />
          </div>
        }
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <div style={{ padding: '0px 10px' }}>
                <Tooltip title='Повернутись до списку відомостей'>
                  <IconButton
                    aria-label='delete'
                    onClick={() =>
                      navigate(
                        api.router.certifications.Statement(certificationsId)
                      )
                    }
                  >
                    <KeyboardBackspaceIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          ),
        }}
        onGeneratePdf={() =>
          generateProfileInfo({
            variables: {
              id: certificationsId,
              trainerId: trainerId,
            },
          })
        }
        columns={columns}
        data={data ? data : []}
        // onEdit={(e, d) => navigate(api.router.certifications.editAthlete(certificationsId, d.id))}
        onDelete={
          isIntersection(user.types, [USER_TYPES.trainer]) ? null : onDelete
        }
        isDeletableFn={(d) =>
          !(
            dataCert.certificate.status == 2 ||
            d.statusStatementAthlete == 3 ||
            d.statusProtocol == 2
          )
        }
      />
    </Paper>
  );
};

export default ListAthlete;
